<template>

  <div class="flex mb-1 mr-1">

    <div class="flex items-center bg-poly-green">

      <div class="px-4 py-2 leading-tight text-xs text-white">
        <span>{{ factor.factorname }}: </span><strong style="font-weight:600;">{{ factor.factorvalue }}</strong>
      </div>

    </div>

    <button
      v-if="removable"
      @click="removeFactor"
      class="bg-poly-red px-1 rounded-r" style="margin-left:1px">
      <svg-close class="text-white" width="1rem" />
    </button>

  </div>

</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {

  name: 'FactorBadge',

  props: {

    factor: { type: Object },

    removable: { type: Boolean, default: false }

  },

  computed: {

    ...mapState(['stateid'])

  },

  methods: {

    ...mapActions(['applyAction']),

    removeFactor() {

      let action = {
        action: 'remove_factor',
        factorvalueid: this.factor.factorvalueid,
        stateid: this.stateid
      };

      this.applyAction(action);

    }

  }

}
</script>
